module.exports = __webpack_public_path__ + "static/media/americanexpress.721334cd.svg";